import ProgressBar from './progress-bar';

export default ProgressBar;
